import { IKyHieuHoaDon } from "../../../model/respone/hoa-don-dien-tu/IKyHieuHoaDon";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKyHieuHoaDonActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IKyHieuHoaDon[],
  LOAD_ERRR: "",

  SAVE_START: {} as IKyHieuHoaDon,
  SAVE_SUCCESS: {} as IKyHieuHoaDon,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IKyHieuHoaDon,
  CLOSE_EDIT_MODAL: undefined,
};
export const eKyHieuHoaDonActionIds = generateActionTypeIds(
  eKyHieuHoaDonActionsObj,
  "KY_HIEU_HOA_DON"
);
export type IKyHieuHoaDonActionTypes = IGenericActionType<
  typeof eKyHieuHoaDonActionsObj,
  "KY_HIEU_HOA_DON"
>;
